import React from 'react';
import MediaQuery from 'react-responsive';

import useScreenMode from '../../../hooks/useScreenMode';
import { getImagesStaticUrl } from '../../../helpers';
import { DESKTOP } from '../../constants';
import { text } from '../disclaimerText';
import ReactivateButton from '../ReactivateButton';
import styles from './mainBanner.module.scss';

const MainBanner = ({ couponsApplied, isLoading, setIsLoading }) => {
  const screenMode = useScreenMode();
  const imageToShow = screenMode !== DESKTOP ? 'reactivate-today-box.png' : 'reactivate-today-box@2x.png';
  return (
    <section className={styles['today-main-banner']}>
      <div className={styles['today-main-banner__image-container']}>
        <img
          src={getImagesStaticUrl(imageToShow)}
          alt="Open box"
        />
      </div>
      <div className={styles['today-main-banner__title-container']}>
        <h1 className={styles['today-main-banner__title']}>Reactivate Your Membership</h1>
        <p className={styles['today-main-banner__description']}>
          Don’t miss out on the seasonal box, access to members only sales, and other amazing membership perks.
        </p>
        <MediaQuery minDeviceWidth={768}>
          <p className={styles.disclaimer}>{text}</p>
          <ReactivateButton couponsApplied={couponsApplied} isLoading={isLoading} setIsLoading={setIsLoading} />
        </MediaQuery>
      </div>
    </section>
  );
};

export default MainBanner;
